import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { categories } from "@/utils/catalog";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="w-full max-w-lg rounded-lg border border-background-200 bg-background-100/60 p-8 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-background-50 text-foreground-400">
            <i className="ri-compass-3-line text-2xl" />
          </span>
          <h1 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
            页面走丢了
          </h1>
          <p className="mt-2 break-all font-mono text-xs text-foreground-400">{location.pathname}</p>
          <p className="mt-3 text-sm text-foreground-500">
            这个地址不存在或已经调整，你可以从下面的入口重新开始。
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            {categories.map((item) => (
              <Link
                key={item.slug}
                to={`/category/${item.slug}`}
                className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                {item.name}
              </Link>
            ))}
          </div>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" /> 返回首页
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}